<template>
	<div id="Paginas">
		<v-container>
			<!--//* Adicionar comentário  -->
			<v-dialog v-model="addCommentModal.enabled" max-width="600px">
				<v-card>
					<v-card-title>
						<span class="headline">Editar comentário</span>
					</v-card-title>
					<v-card-text>
						<v-textarea solo v-model="comentarioDigitado"/>
					</v-card-text>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn color="blue darken-1" flat @click="addCommentModal.enabled = false">Cancelar</v-btn>
						<v-btn color="blue darken-1" flat @click="addComment()">Adicionar</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>
			<!--//* Editar comentário  -->
			<v-dialog v-model="editCommentModal.enabled" max-width="600px">
				<v-card>
					<v-card-title>
						<span class="headline">Editar comentário</span>
					</v-card-title>
					<v-card-text>
						<v-textarea solo v-model="comentarioDigitado"/>
					</v-card-text>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn color="blue darken-1" flat @click="editCommentModal.enabled = false">Cancelar</v-btn>
						<v-btn color="blue darken-1" flat @click="editComment()">Atualizar</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>
			<!--//* Deletar comentário  -->
			<v-dialog v-model="deleteCommentModal.enabled" max-width="600px">
				<v-card>
					<v-card-title>
						<span class="headline">Deseja deletar este comentário?</span>
					</v-card-title>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn color="blue darken-1" flat @click="deleteCommentModal.enabled = false">Cancelar</v-btn>
						<v-btn color="blue darken-1" flat @click="deleteComment()">Deletar</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>

			<v-layout>
				<v-flex md8>
					<!-- //*Speed dial para aprovação do site (mobile) -->
					<v-speed-dial v-model="dial" bottom right small fixed direction="top" class="r-margin-bottom hidden-md-and-up">
						<v-btn slot="activator" v-model="dial" color="extra" dark icon large>
							<v-icon>more_vert</v-icon>
						</v-btn>
						<v-tooltip left>
							<v-btn fab small dark slot="activator" class="hidden-md-and-up" color="accent" @click="bottomComments.enabled = !bottomComments.enabled">
								<v-icon small>comment</v-icon>
							</v-btn>
							<span>Comentários</span>
						</v-tooltip>
						<v-tooltip left>
							<v-btn @click="reprovar()" slot="activator" color="error" fab small dark>
								<v-icon>close</v-icon>
							</v-btn>
							<span>Reprovar</span>
						</v-tooltip>
						<v-tooltip left>
							<v-btn @click="aprovar()" slot="activator" fab small color="success" dark>
								<v-icon>done</v-icon>
							</v-btn>
							<span>Aprovar</span>
						</v-tooltip>
					</v-speed-dial>

					<!-- //*Menu de seleção de páginas -->
					<v-card>
						<v-tabs v-model="tabs" slider-color="accent" show-arrows>
							<v-tab v-for="item in sites.paginas" :key="item.nome" @click="paginaSelecionada = item">
								{{item.nome}}
							</v-tab>
							<v-spacer/>
							<!-- //* Aprovação no desktop -->
							<template class="r-float-right hidden-sm-and-down">
								<v-btn color="success" @click="aprovar()">Aprovar</v-btn>
								<v-btn color="error" @click="reprovar()">Reprovar</v-btn>
							</template>
							<v-tab-item v-for="item in sites.paginas" :key="item.nome">
								<div class="pa-2 r-border-top" v-html="item.content"></div>
							</v-tab-item>
						</v-tabs>
					</v-card>
				</v-flex>

				<v-flex xs4 ml-3 class="hidden-sm-and-down">
		<!-- //* Card de situação -->
					<v-card class="mb-3">
						<v-card-title class="r-capitalize" :class="situationColor">
							<span v-if="paginaSelecionada != null"> Página: {{paginaSelecionada.nome}} </span>
							<v-spacer/>
							<span v-if="paginaSelecionada"> {{paginaSelecionada.situation}} </span>
						</v-card-title>
					</v-card>

					<!-- //*Comentários -->
					<v-card class="mb-3">
						<v-card-text>
							<span class="subheading r-bold">Comentário:</span>
							<span class="text-xs-right r-float-right">
									<v-tooltip bottom>
										<v-icon slot="activator" @click="editCommentConfirm()">edit</v-icon>
										<span>Editar comentário</span>
									</v-tooltip>
									<v-tooltip bottom>
										<v-icon slot="activator" @click="deleteCommentModal.enabled = true">delete</v-icon>
										<span>Deletar comentário</span>
									</v-tooltip>
								</span>
							<div><small>Selecione uma área para fazer um comentário localizado</small></div>
							<div v-if="paginaSelecionada">{{paginaSelecionada.comentario}}</div>
							<template v-if="paginaSelecionada">
								<div v-if="paginaSelecionada.comentario == null" class="mt-3">
									<v-btn block color="accent" @click="addCommentModal.enabled = true"><v-icon>add</v-icon>Adicionar comentário</v-btn>
								</div>
							</template>
						</v-card-text>
					</v-card>
					
				</v-flex>
			</v-layout>
			<!-- //*Comentários no Mobile -->
			<v-bottom-sheet v-model="bottomComments.enabled">
				<v-card>
					<v-card-text>
						<span class="subheading r-bold">Comentário:</span>
						<span class="text-xs-right r-float-right">
								<v-tooltip bottom>
									<v-icon color="info" slot="activator" @click="editCommentConfirm()">edit</v-icon>
									<span>Editar comentário</span>
								</v-tooltip>
								<v-tooltip bottom>
									<v-icon color="error" slot="activator" @click="deleteCommentModal.enabled = true">delete</v-icon>
									<span>Deletar comentário</span>
								</v-tooltip>
							</span>
						<template v-if="paginaSelecionada">
							<div v-if="paginaSelecionada.comentario == null" class="mt-3">
								<v-btn block color="accent" @click="addCommentModal.enabled = true"><v-icon>add</v-icon>Adicionar comentário</v-btn>
							</div>
						</template>
						<div v-if="paginaSelecionada">{{paginaSelecionada.comentario}}</div>
					</v-card-text>
				</v-card>
			</v-bottom-sheet>
			
			<!-- //*Snackbar de aviso -->
			<v-snackbar v-model="alert.enabled" top :timeout="alert.time" :color="alert.color">
				{{alert.content}}
			</v-snackbar>

		</v-container>
	</div>
</template>

<script>
import { db } from '../firebase'
import Vue from 'vue';

const sitesRef = db.ref('sites')

export default {
    name: 'Paginas',

		firebase(){
			return {
				sites: {
					source: sitesRef.child(this.$route.query.siteId),
          asObject: true
				},
				paginaSelecionadaUrl: {
					source: sitesRef.child(this.$route.query.siteId + '/paginas/')
				}
			}
		},

    data () {
			return {
				sites: {},
				siteId: null,

				//*Comentários abaixo da página
				bottomComments: {
					enabled: false,
				},
				//*Modal de confirmação de deleteComment
				deleteCommentModal: {
					enabled: false,
				},
				//*Modal de adicionar comentário
				addCommentModal: {
					enabled: false,
				},
				//*Comentário a ser adicionado
				comentarioDigitado: null,
				//*Modal de editar comentário
				editCommentModal: {
					enabled: false,
				},
				//*Dial para aprovação do site
				dial: false,
				//*Snackbar para alertar a opção
				alert: {
					enabled: false,
					content: '',
					time: 2002,
					color: 'primary'
				},
				//*Cor da situação do site
				situationColor: '',
				//*Exibiçã das páginas no menu em cima
				tabs: -1,
				//* Seleção de páginas
				paginaSelecionada: null,
			}
		},
		methods: {
			//*Opções CRUD
			addComment() {
				sitesRef.child(this.$route.query.siteId + '/paginas/' + this.paginaSelecionada.chave).update({
          comentario: this.comentarioDigitado
        }).then(function(){
          this.addCommentModal.enabled = false
        }.bind(this))
			},
			editCommentConfirm() {
				this.editCommentModal.enabled = true,
				this.comentarioDigitado = this.paginaSelecionada.comentario
			},
      editComment() {
				sitesRef.child(this.$route.query.siteId + '/paginas/' + this.paginaSelecionada.chave).update({
          comentario: this.comentarioDigitado
        }).then(function(){
          this.editCommentModal.enabled = false
        }.bind(this))
			},
			deleteComment() {
				sitesRef.child(this.$route.query.siteId + '/paginas/' + this.paginaSelecionada.chave+ '/comentario').remove().then(function(){
          this.deleteCommentModal.enabled = false
        }.bind(this))
			},
			//*Aprovações
			aprovar() {
				sitesRef.child(this.$route.query.siteId + '/paginas/' + this.paginaSelecionada.chave).update({
					situation: 'aprovado'
				}).then(function(){
					this.alert.enabled = true
					this.alert.content = 'Aprovado!'
					this.alert.color = 'success'
					console.log(this.paginaSelecionada)
					if(this.paginaSelecionada != null){
						if(this.paginaSelecionada.situation == 'aprovado') {
							this.situationColor = 'success white--text'
						}else if(this.paginaSelecionada.situation == 'reprovado'){
							this.situationColor = 'error white--text'
						}else {
							this.situationColor = ''
						}
					}
				}.bind(this))
			},
			reprovar() {
				sitesRef.child(this.$route.query.siteId + '/paginas/' + this.paginaSelecionada.chave).update({
					situation: 'reprovado'
				}).then(
					this.alert.enabled = true,
					this.alert.content = 'Reprovado!',
					this.alert.color = 'error',
				)
			}
		},	
		//*Definir a pagina como a selecionada pela URL
    mounted () {
      this.pagina = this.$route.query.paginaId
			this.paginaSelecionada = this.paginaSelecionadaUrl[0]
    },
		watch: {
			//*
			sites: {
				deep: true,
				handler(siteAtual) {
					if(this.paginaSelecionada){
						var situacaoTemp = siteAtual.paginas[this.paginaSelecionada.chave].situation
						if(situacaoTemp == 'aprovado') {
							this.situationColor = 'success white--text'
						}else if(situacaoTemp == 'reprovado'){
							this.situationColor = 'error white--text'
						}else {
							this.situationColor = ''
						}

						var comentarioTemp = siteAtual.paginas[this.paginaSelecionada.chave].comentario
						this.paginaSelecionada.comentario = comentarioTemp
					}
					if(this.paginaSelecionada == null){	
						this.paginaSelecionada = this.paginaSelecionadaUrl[0]
					}
				}
			},
			//*Handler para mudar a cor
			paginaSelecionada: {
				deep: true,
				handler() {
					if(this.paginaSelecionada != null){
						if(this.paginaSelecionada.situation == 'aprovado') {
							this.situationColor = 'success white--text'
						}else if(this.paginaSelecionada.situation == 'reprovado'){
							this.situationColor = 'error white--text'
						}else {
							this.situationColor = ''
						}
					}
				}
			}
		}
}
</script>

<style lang="sass">
// *Style da Resultam
.r-margin-bottom
	margin-bottom: 40px

.r-capitalize
	text-transform: capitalize

.r-border-top
	border-top: 1px solid rgba(0, 0, 0, 0.14) !important

// *Alterações de Style do Vuetify

</style>
